import React, { useCallback } from 'react';
import Text from 'components/Text/Text';
import { Form, Checkbox } from 'antd';
import { CheckboxChangeEvent } from 'antd/lib/checkbox';

interface IProps {
	toggleTaxPercentProtectedFromSync: (value: boolean) => void;
	isTaxPercentProtectedFromSync: boolean;
}

export const IsProtectedFromSync: React.FC<IProps> = ({
	toggleTaxPercentProtectedFromSync,
	isTaxPercentProtectedFromSync,
}) => {
	const handleChange = useCallback(
		(e: CheckboxChangeEvent) => toggleTaxPercentProtectedFromSync(e.target.checked),
		[toggleTaxPercentProtectedFromSync],
	);

	return (
		<Form.Item name="isTaxPercentProtectedFromSync">
			<Checkbox checked={isTaxPercentProtectedFromSync} onChange={handleChange}>
				<Text translationNameSpace="form" translationKey="protectFromSyncLabel" asFragment={true} />
			</Checkbox>
		</Form.Item>
	);
};
